(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('newSupplier', newSupplierController);

	newSupplierController.$inject = ['$rootScope', '$scope', '$timeout', '$experiments'];

	function newSupplierController($rootScope, $scope, $timeout, $experiments) {
		var vm = this;
		vm.showAddCriticalityLevel = true;

		$scope.type = 'customer';
		$scope.siteId = globalConfig.factory.id;
		$scope.customerId = globalConfig.customer.id;
	}
})();